import TerminalWindow from './TerminalWindow';

const industries = [
  'Fintech',
  'Real Estate',
  'Utilities',
  'Field Service',
  'Enterprise SaaS',
];

export default function TrustSignals() {
  return (
    <>
      {/* Industries strip */}
      <section className="industries-section">
        <div className="section-inner">
          <p className="industries-eyebrow">Industries served</p>
          <div className="industries-strip">
            {industries.map((ind) => (
              <span key={ind} className="industry-chip">{ind}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Terminal demo */}
      <section className="terminal-section">
        <div className="section-inner terminal-section-inner">
          <div className="terminal-section-text">
            <p className="section-eyebrow">What we actually do</p>
            <h2 className="terminal-section-heading">
              Audit. Fix. Ship.
            </h2>
            <p className="terminal-section-sub">
              From a broken prototype to a production-grade system — end to end,
              no hand-holding required.
            </p>
          </div>
          <TerminalWindow />
        </div>
      </section>
    </>
  );
}
